/**
 * Handles toggling the main navigation menu for small screens.
 */
jQuery( document ).ready( function( $ ) {
	var $masthead = $( '#masthead' ),
	    timeout = false;
		
	$masthead.find( '.main-navigation' ).addClass( 'visible' );

	$.fn.smallMenu = function() {
		$masthead.find( '#site-navigation' ).removeClass( 'main-navigation' ).addClass( 'main-small-navigation' );
		$masthead.find( '#site-navigation h3' ).removeClass( 'assistive-text' ).addClass( 'menu-toggle' );

		$( '.menu-toggle' ).unbind( 'click' ).click( function() {
			$masthead.find( '.menu-primary-menu-container' ).toggleClass( 'toggled-on' );
			$( this ).toggleClass( 'toggled-on' );
		} );
	};

	// Check viewport width on first load.
	if ( $( window ).width() < 800 )
		$.fn.smallMenu();

	// Check viewport width when user resizes the browser window.
	$( window ).resize( function() {
		var browserWidth = $( window ).width();

		if ( false !== timeout )
			clearTimeout( timeout );

		timeout = setTimeout( function() {
			if ( browserWidth < 800 ) {
				$.fn.smallMenu();
			} else {
				$masthead.find( '#site-navigation' ).removeClass( 'main-small-navigation' ).addClass( 'main-navigation' );
				$masthead.find( '#site-navigation h3' ).removeClass( 'menu-toggle' ).addClass( 'assistive-text' );
			}
		}, 200 );
	} );
	
	/* Change the color of select items depending on if they are seleceted */
	document.querySelectorAll('select').forEach(sel => {
		sel.addEventListener('change', function() {
			this.style.color = this.selectedIndex === 0 ? 'var(--light_grey)' : 'var(--black)';
		});
	});
	
	/* Image animation */
	const images = document.querySelectorAll(".animate-on-visible");

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add("is-inViewport");
                observer.unobserve(entry.target); // Stop observing once zoom is triggered
            }
        });
    }, {
        threshold: 0.2 // Trigger when 20% of the element is visible
    });

    images.forEach(image => {
        observer.observe(image);
    });
	
	// Stop menu page jump when using #
	document.querySelectorAll('.menu-item-has-children > a[href="#"]').forEach(el => {
		el.addEventListener('click', e => e.preventDefault());
	});
	
	
	// Smooth scrolling
	$('.main-navigation a[href*="#"], .read-more a[href*="#"]').on('click', function(e) {
		// Only run if the link is an internal anchor (starts with #)
		if (this.hash !== "") {
			const target = $(this.hash);
			
			if (target.length) {
				e.preventDefault();
				
				$('html, body').stop().animate({
					scrollTop: target.offset().top - 100 // Matches your CSS scroll-padding
				}, 800);
				
				// Optional: Update URL without jumping
				window.history.pushState(null, null, this.hash);
			}
		}
	});
	
} );
